[
  {
    "path": "/learn",
    "title": "Options Theory",
    "description": "Learn options with strategy cards, foundations, Greeks and quizzes. Explore seven structures in an interactive payoff simulator without signing up.",
    "title_zh": "期权理论与策略学习",
    "description_zh": "从期权基础、希腊字母到策略结构，通过示例和交互模拟理解盈亏与风险。无需登录即可学习和探索。"
  },
  {
    "path": "/learn/strategies",
    "title": "Options Strategies",
    "description": "Explore option structures: construction, examples, behavior and risks.",
    "title_zh": "期权策略学习指南",
    "description_zh": "了解各类期权策略的合约组成、计算示例、变化特点和风险，并进入交互模拟。"
  },
  {
    "path": "/learn/foundations",
    "title": "Options Foundations",
    "description": "Understand calls, puts, strikes, expiration, premiums and option payoff with worked examples.",
    "title_zh": "期权入门：基础概念与计算示例",
    "description_zh": "学习看涨与看跌期权、行权价、到期日、权利金和到期盈亏，通过实例理解期权基础。"
  },
  {
    "path": "/learn/greeks",
    "title": "Option Greeks",
    "description": "Learn Delta, Gamma, Theta, Vega and Rho with explanations and examples.",
    "title_zh": "期权希腊字母：Delta、Gamma、Theta、Vega、Rho",
    "description_zh": "通过解释与示例，理解期权对价格、时间、波动率和利率变化的敏感度。"
  },
  {
    "path": "/learn/quiz",
    "title": "Options Quiz",
    "description": "Practice options foundations, Greeks and strategy recognition with educational quizzes.",
    "title_zh": "期权知识练习",
    "description_zh": "练习期权基础、希腊字母和策略识别，检查理解并查看答案解析。"
  },
  {
    "path": "/learn/greeks/delta",
    "title": "Option Delta",
    "description": "Understand Delta: what it measures, how it changes and an illustrative example.",
    "title_zh": "期权 Delta：含义、变化与实例",
    "description_zh": "理解 Delta 衡量什么、如何变化，并通过示例学习其在期权分析中的含义。"
  },
  {
    "path": "/learn/greeks/gamma",
    "title": "Option Gamma",
    "description": "Understand Gamma: what it measures, how it changes and an illustrative example.",
    "title_zh": "期权 Gamma：含义、变化与实例",
    "description_zh": "理解 Gamma 衡量什么、如何变化，并通过示例学习其在期权分析中的含义。"
  },
  {
    "path": "/learn/greeks/theta",
    "title": "Option Theta",
    "description": "Understand Theta: what it measures, how it changes and an illustrative example.",
    "title_zh": "期权 Theta：含义、变化与实例",
    "description_zh": "理解 Theta 衡量什么、如何变化，并通过示例学习其在期权分析中的含义。"
  },
  {
    "path": "/learn/greeks/vega",
    "title": "Option Vega",
    "description": "Understand Vega: what it measures, how it changes and an illustrative example.",
    "title_zh": "期权 Vega：含义、变化与实例",
    "description_zh": "理解 Vega 衡量什么、如何变化，并通过示例学习其在期权分析中的含义。"
  },
  {
    "path": "/learn/greeks/rho",
    "title": "Option Rho",
    "description": "Understand Rho: what it measures, how it changes and an illustrative example.",
    "title_zh": "期权 Rho：含义、变化与实例",
    "description_zh": "理解 Rho 衡量什么、如何变化，并通过示例学习其在期权分析中的含义。"
  },
  {
    "path": "/learn/strategies/single-call",
    "title": "Call Strategy",
    "description": "Learn the call structure, how the numbers work, its behavior and risks.",
    "title_zh": "买入看涨期权策略：原理、盈亏与风险",
    "description_zh": "学习买入看涨期权策略的组成、盈亏计算、变化特点和风险，通过数字示例理解策略。"
  },
  {
    "path": "/learn/strategies/single-call/explore",
    "title": "Call Payoff Simulator",
    "description": "Explore an illustrative call example. Edit option contracts and premiums and see the expiration payoff. No sign-up needed to explore.",
    "title_zh": "买入看涨期权盈亏模拟器",
    "description_zh": "修改买入看涨期权示例的合约和权利金，探索到期盈亏与盈亏平衡点。示例价格仅供学习，模拟无需登录。"
  },
  {
    "path": "/learn/strategies/single-put",
    "title": "Put Strategy",
    "description": "Learn the put structure, how the numbers work, its behavior and risks.",
    "title_zh": "买入看跌期权策略：原理、盈亏与风险",
    "description_zh": "学习买入看跌期权策略的组成、盈亏计算、变化特点和风险，通过数字示例理解策略。"
  },
  {
    "path": "/learn/strategies/single-put/explore",
    "title": "Put Payoff Simulator",
    "description": "Explore an illustrative put example. Edit option contracts and premiums and see the expiration payoff. No sign-up needed to explore.",
    "title_zh": "买入看跌期权盈亏模拟器",
    "description_zh": "修改买入看跌期权示例的合约和权利金，探索到期盈亏与盈亏平衡点。示例价格仅供学习，模拟无需登录。"
  },
  {
    "path": "/learn/strategies/covered-call",
    "title": "Covered Call Strategy",
    "description": "Learn the covered call structure, how the numbers work, its behavior and risks.",
    "title_zh": "备兑看涨期权策略：原理、盈亏与风险",
    "description_zh": "学习备兑看涨期权策略的组成、盈亏计算、变化特点和风险，通过数字示例理解策略。"
  },
  {
    "path": "/learn/strategies/cash-secured-put",
    "title": "Cash Secured Put Strategy",
    "description": "Learn the cash secured put structure, how the numbers work, its behavior and risks.",
    "title_zh": "现金担保卖出看跌期权策略：原理、盈亏与风险",
    "description_zh": "学习现金担保卖出看跌期权策略的组成、盈亏计算、变化特点和风险，通过数字示例理解策略。"
  },
  {
    "path": "/learn/strategies/bull-call-spread",
    "title": "Bull Call Spread Strategy",
    "description": "Learn the bull call spread structure, how the numbers work, its behavior and risks.",
    "title_zh": "牛市看涨价差策略：原理、盈亏与风险",
    "description_zh": "学习牛市看涨价差策略的组成、盈亏计算、变化特点和风险，通过数字示例理解策略。"
  },
  {
    "path": "/learn/strategies/bull-call-spread/explore",
    "title": "Bull Call Spread Payoff Simulator",
    "description": "Explore an illustrative bull call spread example. Edit option contracts and premiums and see the expiration payoff. No sign-up needed to explore.",
    "title_zh": "牛市看涨价差盈亏模拟器",
    "description_zh": "修改牛市看涨价差示例的合约和权利金，探索到期盈亏与盈亏平衡点。示例价格仅供学习，模拟无需登录。"
  },
  {
    "path": "/learn/strategies/bear-put-spread",
    "title": "Bear Put Spread Strategy",
    "description": "Learn the bear put spread structure, how the numbers work, its behavior and risks.",
    "title_zh": "熊市看跌价差策略：原理、盈亏与风险",
    "description_zh": "学习熊市看跌价差策略的组成、盈亏计算、变化特点和风险，通过数字示例理解策略。"
  },
  {
    "path": "/learn/strategies/bear-put-spread/explore",
    "title": "Bear Put Spread Payoff Simulator",
    "description": "Explore an illustrative bear put spread example. Edit option contracts and premiums and see the expiration payoff. No sign-up needed to explore.",
    "title_zh": "熊市看跌价差盈亏模拟器",
    "description_zh": "修改熊市看跌价差示例的合约和权利金，探索到期盈亏与盈亏平衡点。示例价格仅供学习，模拟无需登录。"
  },
  {
    "path": "/learn/strategies/bull-put-spread",
    "title": "Bull Put Spread Strategy",
    "description": "Learn the bull put spread structure, how the numbers work, its behavior and risks.",
    "title_zh": "牛市看跌价差策略：原理、盈亏与风险",
    "description_zh": "学习牛市看跌价差策略的组成、盈亏计算、变化特点和风险，通过数字示例理解策略。"
  },
  {
    "path": "/learn/strategies/bear-call-spread",
    "title": "Bear Call Spread Strategy",
    "description": "Learn the bear call spread structure, how the numbers work, its behavior and risks.",
    "title_zh": "熊市看涨价差策略：原理、盈亏与风险",
    "description_zh": "学习熊市看涨价差策略的组成、盈亏计算、变化特点和风险，通过数字示例理解策略。"
  },
  {
    "path": "/learn/strategies/iron-fly",
    "title": "Iron Fly Strategy",
    "description": "Learn the iron fly structure, how the numbers work, its behavior and risks.",
    "title_zh": "铁蝶策略：原理、盈亏与风险",
    "description_zh": "学习铁蝶策略的组成、盈亏计算、变化特点和风险，通过数字示例理解策略。"
  },
  {
    "path": "/learn/strategies/iron-condor",
    "title": "Iron Condor Strategy",
    "description": "Learn the iron condor structure, how the numbers work, its behavior and risks.",
    "title_zh": "铁鹰策略：原理、盈亏与风险",
    "description_zh": "学习铁鹰策略的组成、盈亏计算、变化特点和风险，通过数字示例理解策略。"
  },
  {
    "path": "/learn/strategies/iron-condor/explore",
    "title": "Iron Condor Payoff Simulator",
    "description": "Explore an illustrative iron condor example. Edit option contracts and premiums and see the expiration payoff. No sign-up needed to explore.",
    "title_zh": "铁鹰盈亏模拟器",
    "description_zh": "修改铁鹰示例的合约和权利金，探索到期盈亏与盈亏平衡点。示例价格仅供学习，模拟无需登录。"
  },
  {
    "path": "/learn/strategies/butterfly",
    "title": "Butterfly Strategy",
    "description": "Learn the butterfly structure, how the numbers work, its behavior and risks.",
    "title_zh": "蝶式价差策略：原理、盈亏与风险",
    "description_zh": "学习蝶式价差策略的组成、盈亏计算、变化特点和风险，通过数字示例理解策略。"
  },
  {
    "path": "/learn/strategies/butterfly/explore",
    "title": "Butterfly Payoff Simulator",
    "description": "Explore an illustrative butterfly example. Edit option contracts and premiums and see the expiration payoff. No sign-up needed to explore.",
    "title_zh": "蝶式价差盈亏模拟器",
    "description_zh": "修改蝶式价差示例的合约和权利金，探索到期盈亏与盈亏平衡点。示例价格仅供学习，模拟无需登录。"
  },
  {
    "path": "/learn/strategies/broken-wing-butterfly",
    "title": "Broken Wing Butterfly Strategy",
    "description": "Learn the broken wing butterfly structure, how the numbers work, its behavior and risks.",
    "title_zh": "折翼蝶式策略：原理、盈亏与风险",
    "description_zh": "学习折翼蝶式策略的组成、盈亏计算、变化特点和风险，通过数字示例理解策略。"
  },
  {
    "path": "/learn/strategies/long-condor",
    "title": "Long Condor Strategy",
    "description": "Learn the long condor structure, how the numbers work, its behavior and risks.",
    "title_zh": "买入秃鹰价差策略：原理、盈亏与风险",
    "description_zh": "学习买入秃鹰价差策略的组成、盈亏计算、变化特点和风险，通过数字示例理解策略。"
  },
  {
    "path": "/learn/strategies/short-condor",
    "title": "Short Condor Strategy",
    "description": "Learn the short condor structure, how the numbers work, its behavior and risks.",
    "title_zh": "卖出秃鹰价差策略：原理、盈亏与风险",
    "description_zh": "学习卖出秃鹰价差策略的组成、盈亏计算、变化特点和风险，通过数字示例理解策略。"
  },
  {
    "path": "/learn/strategies/jade-lizard",
    "title": "Jade Lizard Strategy",
    "description": "Learn the jade lizard structure, how the numbers work, its behavior and risks.",
    "title_zh": "玉蜥蜴策略：原理、盈亏与风险",
    "description_zh": "学习玉蜥蜴策略的组成、盈亏计算、变化特点和风险，通过数字示例理解策略。"
  },
  {
    "path": "/learn/strategies/ratio-backspread",
    "title": "Ratio Backspread Strategy",
    "description": "Learn the ratio backspread structure, how the numbers work, its behavior and risks.",
    "title_zh": "反向比例价差策略：原理、盈亏与风险",
    "description_zh": "学习反向比例价差策略的组成、盈亏计算、变化特点和风险，通过数字示例理解策略。"
  },
  {
    "path": "/learn/strategies/ratio-spread",
    "title": "Ratio Spread Strategy",
    "description": "Learn the ratio spread structure, how the numbers work, its behavior and risks.",
    "title_zh": "比例价差策略：原理、盈亏与风险",
    "description_zh": "学习比例价差策略的组成、盈亏计算、变化特点和风险，通过数字示例理解策略。"
  },
  {
    "path": "/learn/strategies/bull-call-ladder",
    "title": "Bull Call Ladder Strategy",
    "description": "Learn the bull call ladder structure, how the numbers work, its behavior and risks.",
    "title_zh": "牛市看涨阶梯策略：原理、盈亏与风险",
    "description_zh": "学习牛市看涨阶梯策略的组成、盈亏计算、变化特点和风险，通过数字示例理解策略。"
  },
  {
    "path": "/learn/strategies/bear-call-ladder",
    "title": "Bear Call Ladder Strategy",
    "description": "Learn the bear call ladder structure, how the numbers work, its behavior and risks.",
    "title_zh": "熊市看涨阶梯策略：原理、盈亏与风险",
    "description_zh": "学习熊市看涨阶梯策略的组成、盈亏计算、变化特点和风险，通过数字示例理解策略。"
  },
  {
    "path": "/learn/strategies/bull-put-ladder",
    "title": "Bull Put Ladder Strategy",
    "description": "Learn the bull put ladder structure, how the numbers work, its behavior and risks.",
    "title_zh": "牛市看跌阶梯策略：原理、盈亏与风险",
    "description_zh": "学习牛市看跌阶梯策略的组成、盈亏计算、变化特点和风险，通过数字示例理解策略。"
  },
  {
    "path": "/learn/strategies/bear-put-ladder",
    "title": "Bear Put Ladder Strategy",
    "description": "Learn the bear put ladder structure, how the numbers work, its behavior and risks.",
    "title_zh": "熊市看跌阶梯策略：原理、盈亏与风险",
    "description_zh": "学习熊市看跌阶梯策略的组成、盈亏计算、变化特点和风险，通过数字示例理解策略。"
  },
  {
    "path": "/learn/strategies/synthetic-future",
    "title": "Synthetic Future Strategy",
    "description": "Learn the synthetic future structure, how the numbers work, its behavior and risks.",
    "title_zh": "合成期货策略：原理、盈亏与风险",
    "description_zh": "学习合成期货策略的组成、盈亏计算、变化特点和风险，通过数字示例理解策略。"
  },
  {
    "path": "/learn/strategies/combo",
    "title": "Combo Strategy",
    "description": "Learn the combo structure, how the numbers work, its behavior and risks.",
    "title_zh": "组合期权策略：原理、盈亏与风险",
    "description_zh": "学习组合期权策略的组成、盈亏计算、变化特点和风险，通过数字示例理解策略。"
  },
  {
    "path": "/learn/strategies/straddle",
    "title": "Straddle Strategy",
    "description": "Learn the straddle structure, how the numbers work, its behavior and risks.",
    "title_zh": "跨式策略：原理、盈亏与风险",
    "description_zh": "学习跨式策略的组成、盈亏计算、变化特点和风险，通过数字示例理解策略。"
  },
  {
    "path": "/learn/strategies/straddle/explore",
    "title": "Straddle Payoff Simulator",
    "description": "Explore an illustrative straddle example. Edit option contracts and premiums and see the expiration payoff. No sign-up needed to explore.",
    "title_zh": "跨式盈亏模拟器",
    "description_zh": "修改跨式示例的合约和权利金，探索到期盈亏与盈亏平衡点。示例价格仅供学习，模拟无需登录。"
  },
  {
    "path": "/learn/strategies/strangle",
    "title": "Strangle Strategy",
    "description": "Learn the strangle structure, how the numbers work, its behavior and risks.",
    "title_zh": "宽跨式策略：原理、盈亏与风险",
    "description_zh": "学习宽跨式策略的组成、盈亏计算、变化特点和风险，通过数字示例理解策略。"
  },
  {
    "path": "/learn/strategies/strip",
    "title": "Strip Strategy",
    "description": "Learn the strip structure, how the numbers work, its behavior and risks.",
    "title_zh": "偏空跨式策略：原理、盈亏与风险",
    "description_zh": "学习偏空跨式策略的组成、盈亏计算、变化特点和风险，通过数字示例理解策略。"
  },
  {
    "path": "/learn/strategies/strap",
    "title": "Strap Strategy",
    "description": "Learn the strap structure, how the numbers work, its behavior and risks.",
    "title_zh": "偏多跨式策略：原理、盈亏与风险",
    "description_zh": "学习偏多跨式策略的组成、盈亏计算、变化特点和风险，通过数字示例理解策略。"
  },
  {
    "path": "/learn/strategies/guts",
    "title": "Guts Strategy",
    "description": "Learn the guts structure, how the numbers work, its behavior and risks.",
    "title_zh": "实值跨式策略：原理、盈亏与风险",
    "description_zh": "学习实值跨式策略的组成、盈亏计算、变化特点和风险，通过数字示例理解策略。"
  },
  {
    "path": "/learn/strategies/time-spread",
    "title": "Time Spread Strategy",
    "description": "Learn the time spread structure, how the numbers work, its behavior and risks.",
    "title_zh": "日历价差策略：原理、盈亏与风险",
    "description_zh": "学习日历价差策略的组成、盈亏计算、变化特点和风险，通过数字示例理解策略。"
  },
  {
    "path": "/learn/strategies/double-time-spread",
    "title": "Double Time Spread Strategy",
    "description": "Learn the double time spread structure, how the numbers work, its behavior and risks.",
    "title_zh": "双日历价差策略：原理、盈亏与风险",
    "description_zh": "学习双日历价差策略的组成、盈亏计算、变化特点和风险，通过数字示例理解策略。"
  }
]
